import DeviceTable from '../../components/DeviceTable/DeviceTable';
import {Helmet} from "react-helmet";
import React from 'react';
import connectorDevices from '../../content/connectorDevices.json';

const DevicesListPage = () => {

    return (
       
            <div className='row portfolio-row' style={{padding: "2rem"}}>
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>Devices | IOT Platform</title>
                </Helmet>
                {connectorDevices.length > 0 && (
                    <DeviceTable
                        connectorDevices={connectorDevices}
                    />
                )}
            </div>

       
    )
}

export default DevicesListPage;
